import React, { forwardRef } from 'react';
import classNames from 'classnames';

type Props = React.HTMLAttributes<HTMLTableRowElement> & {
  id?: string;
  selectable?: boolean;
  negative?: boolean;
  warning?: boolean;
  color?: string;
  children: React.ReactNode;
};

function TableRow(
  { selectable = false, negative = false, warning = false, color, children = null, className, ...rest }: Props,
  ref: React.ForwardedRef<HTMLTableRowElement>,
) {
  const classes = [];

  if (color) {
    classes.push(color);
  } else if (negative) {
    classes.push('bg-red-50');
  } else if (warning) {
    classes.push('bg-orange-50');
  }

  if (selectable) {
    classes.push('hover:bg-gray-50', 'cursor-pointer');
  }

  return (
    <tr {...rest} ref={ref} className={classNames(classes, className)}>
      {children}
    </tr>
  );
}

export default forwardRef<HTMLTableRowElement, Props>(TableRow);
